import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Chip,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import '../table/CommonTable.scss';

const Sectors = ({ sectors }) => {
    const [showAll, setShowAll] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const displayedSectors = showAll ? sectors : sectors.slice(0, 3);

    const handleShowMore = () => {
        if (sectors.length > 6) {
            setDialogOpen(true);
        } else {
            setShowAll(true);
        }
    };

    return (
        <>
            {displayedSectors.map((sector, index) => (
                <Chip
                    key={index}
                    label={sector}
                    className="sectors__chip"
                />
            ))}
            {sectors.length > 3 && !showAll && (
                <>
                    <span className="sectors__more-text" onClick={handleShowMore}>
                        +{sectors.length - 3} more
                    </span>
                    <KeyboardArrowRightIcon className="sectors__icon" />
                </>
            )}
            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle className="sectors__dialog-title">
                    Sectors
                    <IconButton
                        onClick={() => setDialogOpen(false)}
                        className="sectors__close-button"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className="sectors__dialog-content">
                    {sectors.map((sector, index) => (
                        <Chip
                            key={index}
                            label={sector}
                            className="sectors__chip"
                        />
                    ))}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default Sectors;
